import { ClientIdPrefix } from './types/ClientIdPrefix';

export const isClientId = (id?: string | null): boolean => {
    return id ? id.startsWith(ClientIdPrefix) : false;
};
